import { BodyText, Column, Row } from '@chargify/custom-ui-components';
import React from 'react';

type Props = {
  code: string;
  value: string;
  description: string;
};
export const CouponListItem = ({ code, value, description }: Props) => {
  return (
    <li>
      <Row>
        <Column span={5}>
          <BodyText variant={'body2'} fontWeight={600} color={'gray.dark'}>
            {code}
          </BodyText>
        </Column>
        <Column span={4}>
          <BodyText variant={'body2'} fontWeight={700} color={'success.main'}>
            {value}
          </BodyText>
        </Column>
        <Column span={15}>
          <BodyText variant={'body2'}>{description}</BodyText>
        </Column>
      </Row>
    </li>
  );
};
